// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"mobileNavSearchInput__wrapper__5ecf252c","container":"mobileNavSearchInput__container__5ecf252c","form":"mobileNavSearchInput__form__5ecf252c","input":"mobileNavSearchInput__input__5ecf252c","iconWrapper":"mobileNavSearchInput__iconWrapper__5ecf252c","searchIcon":"mobileNavSearchInput__searchIcon__5ecf252c","closeIcon":"mobileNavSearchInput__closeIcon__5ecf252c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavSearchInput/mobileNavSearchInput.scss
// module id = ./src/components/MobileNav/MobileNavSearchInput/mobileNavSearchInput.scss
// module chunks = 4